<template>
    <section class="title2">
        <ogt-video ref="video" src="/static/video/regio.mp4" poster="/static/video/regio-poster.jpg"></ogt-video>

        <p>Hier werkten we aan in 2020 - onze 5 strategische doelen</p>

        <div class="list">
            <div class="point" @click="$router.push('/Onderwijskwaliteit')">
                <div class="number">1</div>
                <label>Aantoonbare <br/>onderwijs&shy;kwaliteit</label>
            </div>
            <div class="point" @click="$router.push('/Carriere')">
                <div class="number">2</div>
                <label>Opleiden voor <br/>een carri&egrave;re</label>
            </div>
            <div class="point active">
                <div class="number">3</div>
                <label>Positie in <br class="hide-for-small" />de regio</label>
            </div>
            <div class="point" @click="$router.push('/Medewerker')">
                <div class="number">4</div>
                <label>Medewerker<br />3.0</label>
            </div>
            <div class="point" @click="$router.push('/Duurzaam')">
                <div class="number">5</div>
                <label>Duurzaam <br/>verbeteren</label>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
</style>

<script>
    import Tekst from '@/app/pages/regio/Tekst';
    import Interview from '@/app/pages/regio/Interview';
    import OgtVideo from '@/app/components/OgtVideo';
    import Interview2 from '@/app/pages/regio/Interview2';

    import InterviewErdinc from '@/app/pages/sub/InterviewErdinc';
    import InterviewCoen from '@/app/pages/sub/InterviewCoen';
    import Quote from '@/app/pages/regio/Quote.vue';

    export default {
        name: 'Regio',
        meta: {
            title: '4.3 Positie in de regio',
            color: '#FEBE06',
            sub: true,
            slides: [ Tekst, Interview, Quote, Interview2 ]
        },

        components: {
            'ogt-video': OgtVideo
        },

        props: {
            meta: {
                default: () => {},
                type: Object
            }
        },

        mounted()
        {
        },

        methods: {
            focus()
            {
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            },
            sub( name )
            {
                switch( name )
                {
                    case 'Erdinc':
                        this.$emit( 'openOverlay', InterviewErdinc, this.meta.index + 2 );
                        break;
                    case 'Coen':
                        this.$emit( 'openOverlay', InterviewCoen, this.meta.index + 4 );
                        break;
                }
            }
        }
    };
</script>
